// extracted by mini-css-extract-plugin
export var menuIcon = "_qk-0";
export var menuIconInline = "_qk-1";